export default "__VITE_ASSET__B8oxU2SN__"